<template>
  <div class="w-section footer">
    <div class="w-container container">
      <div class="w-row footer-row">
        <div class="w-col w-col-4 footer-column">
          <div class="footer-title">
            Our office
          </div>
          <p>
            <strong>You can find us at:</strong>
            <br>620 Newport Center Drive, Suite 1100
            <br>Newport Beach,&nbsp;California
          </p>
        </div>
        <div class="w-col w-col-4 footer-column">
          <div class="footer-title">
            Call us
          </div>
          <p>
            <strong>For questions you can reach us on:</strong>
            <br>
            <a
              class="link footer-link"
              href="tel:8774117627"
            >
              +1(877)&nbsp;411-ROAR&nbsp;(7627)
            </a>
          </p>
        </div>
        <div class="w-col w-col-4 footer-column last">
          <div class="footer-title">
            mail us!
          </div>
          <p>
            <strong>For questions you can reach us by mail:</strong>
            <br>
            <a
              class="link footer-link"
              href="mailto:info@roaringsky.com"
            >
              info@roaringsky.com
            </a> or use
            <router-link
              :to="{ name: 'Contact' }"
              class="link footer-link"
            >
              the contact form
            </router-link>.
          </p>
        </div>
      </div>
    </div>
    <div class="bottom-footer-block">
      <div class="w-container container">
        <div class="w-row bottom-footer-row">
          <div class="w-col w-col-6 bottom-footer-col-left">
            <p class="bottom-footer-text">
              Copyright {{ currentYear() }} ROARINGSKY inc.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    currentYear() {
      return new Date().getFullYear()
    },
  },
}
</script>
